/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Linked_WechatInputs */

const zh_linked_wechat = /** @type {(inputs: Linked_WechatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`微信`)
};

const en_linked_wechat = /** @type {(inputs: Linked_WechatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WeChat`)
};

const es_linked_wechat = /** @type {(inputs: Linked_WechatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WeChat`)
};

/**
* | output |
* | --- |
* | "WeChat" |
*
* @param {Linked_WechatInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const linked_wechat = /** @type {((inputs?: Linked_WechatInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Linked_WechatInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_linked_wechat(inputs)
	if (locale === "en") return en_linked_wechat(inputs)
	return es_linked_wechat(inputs)
});